// Client copy of server/helpers/csv-utils.js; a shared fixture keeps them in sync.
const FORMULA_TRIGGERS = new Set(['=', '+', '-', '@', '\t', '\r']);

// A bare signed integer evaluates to itself, so it skips the quote.
const SIGNED_NUMBER = /^[+-]\d+$/;

export const addFormulaInjectionGuard = <T>(value: T): T | string => {
  if (typeof value !== 'string' || value.length === 0) {
    return value;
  }
  if (!FORMULA_TRIGGERS.has(value[0])) {
    return value;
  }
  return SIGNED_NUMBER.test(value) ? value : `'${value}`;
};

export const stripFormulaInjectionGuard = <T>(value: T): T | string =>
  typeof value === 'string' &&
  value[0] === "'" &&
  FORMULA_TRIGGERS.has(value[1])
    ? value.slice(1)
    : value;

export const stripCsvRows = (rows: string[][]): string[][] =>
  rows.map((row) => row.map((cell) => stripFormulaInjectionGuard(cell)));

// Arrays are joined first; papaparse would otherwise stringify them unguarded.
export const guardCsvRow = (
  row: Record<string, unknown>,
): Record<string, unknown> =>
  Object.fromEntries(
    Object.entries(row).map(([key, value]) => [
      key,
      addFormulaInjectionGuard(Array.isArray(value) ? value.join(',') : value),
    ]),
  );
